const EditIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_321_1314)">
        <rect
          x="2"
          y="1"
          width="32"
          height="32"
          rx="4"
          fill="none"
          shapeRendering="crispEdges"
        />
        <path
          d="M11 24H12.425L22.2 14.225L20.775 12.8L11 22.575V24V24M9 26V21.75L22.2 8.575C22.4 8.39167 22.6208 8.25 22.8625 8.15C23.1042 8.05 23.3583 8 23.625 8C23.8917 8 24.15 8.05 24.4 8.15C24.65 8.25 24.8667 8.4 25.05 8.6L26.425 10C26.625 10.1833 26.7708 10.4 26.8625 10.65C26.9542 10.9 27 11.15 27 11.4C27 11.6667 26.9542 11.9208 26.8625 12.1625C26.7708 12.4042 26.625 12.625 26.425 12.825L13.25 26H9V26M25 11.4V11.4L23.6 10V10L25 11.4V11.4M21.475 13.525L20.775 12.8V12.8L22.2 14.225V14.225L21.475 13.525V13.525"
          fill="#0F1560"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_321_1314"
          x="0"
          y="0"
          width="36"
          height="36"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_321_1314"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_321_1314"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default EditIcon;
